import { ClosestPointTooltip } from './ClosestPointTooltip/ClosestPointTooltip.js';
import { useLineData } from '../../hooks/useLineData.js';
import type { LineSeriesWithDatapoints } from '../../types/xy-chart-internals.js';
import type { LineDatapoint } from '../../types/xy-chart.js';

export function LineSeriesTooltip({
  datapoint,
  series,
}: Readonly<{
  datapoint: LineDatapoint;
  series: LineSeriesWithDatapoints;
}>) {
  const { seriesToMetadata } = useLineData();
  return (
    <ClosestPointTooltip
      datapoint={datapoint}
      series={series}
      seriesToMetadata={seriesToMetadata}
    />
  );
}
